import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UserAvailableRealmRoles {
  realmRoles: RealmRole[];
}

type RealmRole = {
  id: string;
  name: string;
};

export function useUserAvailableRealmRoles() {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['userAvailableRealmRoles'],
    queryFn: async (): Promise<UserAvailableRealmRoles> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_realm_roles`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'GET',
        }
      );

      let data = await response.json();

      return {
        realmRoles: data?.data || [],
      };
    },
    enabled: keycloak.authenticated,
  });
}
